import { rootDoc } from "../../../../helpers/dom-selectors.js";
import makeHeader from "../../../global-components/header.js";
import SettingsBtn from "../../../global-components/settings-btn.js";
import APP_COMPONENTS from "../components/index.js";
import APP_VIEWS from "./event-router.js";
export default function App({ settingsBtn, settingsOverlay, header, logo }) {
    _initAppShell();
    return Object.freeze({
        resize,
        executeEvent,
        executeEventWithData
    });
    function _initAppShell() {
        SettingsBtn({ settingsBtn, settingsOverlay }).init();
        makeHeader({ header, logo }).init();
        APP_COMPONENTS.discountForm.init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        rootDoc.style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = APP_VIEWS.get(action);
        await view.execute();
    }
    async function executeEventWithData(detail) {
        const view = APP_VIEWS.getWithData(detail.action);
        await view.execute(detail.data);
    }
}
;
